<script lang="ts" setup>
import { useRouteHash } from '@vueuse/router'
import type { BlokTeamList } from '~~/types/storyblok/bloks'
import type {
  ContentTypeTeamStoryList,
  ContentTypeTeamStory,
} from '~~/types/storyblok/stories'
import type { Ref } from 'vue'

defineProps<{ blok?: BlokTeamList }>()

const res = await useAsyncStoryblokStoryQuery({
  content_type: 'ContentTypeTeam',
  starts_with: 'team/member',
  sort_by: 'name:asc',
})
const stories = computed(
  () => res.value.data.stories as ContentTypeTeamStoryList
)

const bio: Ref<ContentTypeTeamStory | undefined> = ref(undefined)
const hash = useRouteHash('')

const openBio = (story: ContentTypeTeamStory) => {
  bio.value = story
  hash.value = `#${story.slug}`
}
const closeBio = () => {
  bio.value = undefined
  // need to keep empty hash, otherwise page will scroll to top
  hash.value = '#'
}

onMounted(() => {
  if (hash.value.length > 1) {
    const bioFromHash = stories.value.find(
      (story) => story.slug === hash.value.slice(1)
    )
    bioFromHash && openBio(bioFromHash)
  }
})
</script>

<template lang="pug">
div(class="blok-team-list container grid grid-cols-12 gap-9 md:gap-36 xl:gap-48")
  TeamMemberListCard(
    v-for="story in stories"
    :key="story.id"
    :story="story"
    class="col-span-12 md:col-span-6 lg:col-span-4"
    @activate="openBio"
  )
  Teleport(to="body")
    transition(name="fade")
      ModalPopup(
        @close-popup="closeBio"
        :active="!!bio"
        v-if="bio"
      )
        TeamMemberDetails(
          :blok="bio.content"
          :title="bio.name"
        )
</template>
